export default class Timer {
	/**
	 * @param element
	 * @param {int} time Number of seconds that the timer should run
	 */
	constructor(element, time = 600) {
		this.element = element;
		this.time = time;
		this._updateDisplay();
		this.interval = setInterval(this._tick.bind(this), 1000);
	}

	_tick() {
		if (this.time > 0) {
			this.time--;
		} else {
			clearInterval(this.interval);
		}
		this._updateDisplay();
	}

	_updateDisplay() {
		let minutes = Math.floor(this.time/60);
		let seconds = this.time%60;

		let output = '';
		if (minutes < 10) {
			output += '0';
		}
		output += minutes;
		output += ':';

		if (seconds < 10) {
			output += '0';
		}
		output += seconds;

		this.element.innerHTML = output;
	}
}
